/** Mirrors quest-server PROMOTION_EVENTS_TIMEZONE until an admin setting replaces it. */
export const PROMOTION_EVENTS_TIMEZONE = "Asia/Kolkata";

export const zonedDateTimeToUtc = (
  year,
  month,
  day,
  hour = 0,
  minute = 0,
  second = 0,
  millisecond = 0,
  timeZone = PROMOTION_EVENTS_TIMEZONE
) => {
  const utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).formatToParts(new Date(utcGuess));
  const read = (type) =>
    Number(parts.find((part) => part.type === type)?.value);
  const zonedAsUtc = Date.UTC(
    read("year"),
    read("month") - 1,
    read("day"),
    read("hour") % 24,
    read("minute"),
    read("second")
  );
  return new Date(utcGuess - (zonedAsUtc - utcGuess) + millisecond);
};

export const promotionCalendarDateKey = (
  value,
  timeZone = PROMOTION_EVENTS_TIMEZONE
) => {
  if (value == null || value === "") return null;
  const parsed = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(parsed);
  const year = parts.find((part) => part.type === "year")?.value;
  const month = parts.find((part) => part.type === "month")?.value;
  const day = parts.find((part) => part.type === "day")?.value;
  if (!year || !month || !day) return null;
  return `${year}-${month}-${day}`;
};

export const startOfNextPromotionDay = (
  dateKey,
  timeZone = PROMOTION_EVENTS_TIMEZONE
) => {
  const [year, month, day] = String(dateKey).split("-").map(Number);
  const next = new Date(Date.UTC(year, month - 1, day));
  next.setUTCDate(next.getUTCDate() + 1);
  return zonedDateTimeToUtc(
    next.getUTCFullYear(),
    next.getUTCMonth() + 1,
    next.getUTCDate(),
    0,
    0,
    0,
    0,
    timeZone
  );
};
